'use client';
import patches from '@/util/intlPatches';
import { Fragment } from 'react';
// import { useIntl } from 'react-intl'
import classes from './price.module.css';

const Price = props => {
  // const { locale } = useIntl()
  const locale = 'en-US';
  const { value, currencyCode, specialPrice } = props;

  const parts = patches.toParts.call(
    new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode ?? 'USD',
    }),
    value,
  );

  const children = parts.map((part, i) => {
    const partClass = classes[part.type];
    const key = `${i}-${part.value}`;

    return (
      <span
        key={key}
        className={partClass}
      >
        {part.value}
      </span>
    );
  });

  const specialPriceChildren = specialPrice
    ? patches.toParts
        .call(
          new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
          }),
          specialPrice,
        )
        .map((part, i) => {
          const partClass = classes[part.type];
          const key = `${i}-${part.value}`;

          return (
            <span
              key={key}
              className={partClass}
            >
              {part.value}
            </span>
          );
        })
    : null;

  return (
    <Fragment>
      {children}
      {specialPriceChildren ? (
        <span className='ml-1 font-sans text-sm leading-5 text-paragraph line-through'>{specialPriceChildren}</span>
      ) : null}
    </Fragment>
  );
};

export default Price;
